import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    if (window.innerWidth < 768) return

    requestIdleCallback(() => {
      this.handler = () => this.#scroll()
      window.addEventListener("scroll", this.handler, { passive: true })
    })
  }

  disconnect() {
    if (this.handler) window.removeEventListener("scroll", this.handler)
  }

  #scroll() {
    const offset = window.scrollY * 0.3
    if (this.hasImageTarget) {
      this.imageTarget.style.transform = `translateY(${offset}px) scale(1.1)`
    }
  }
}
